import styled from 'styled-components';

export const Macrodivisione = styled.tr.withConfig({ displayName: '-Macrodivisione' })`
	& td{
		background-color: #E3E3E3;
		color: #555555;
		font-size: 11px;
		line-height: 14px;
		height: auto !important;
		padding: 7px 14px !important;
	}	
`;
